/**
 * Read-only item-analysis pip (Phase 3).
 *
 * `calibration` is { p_value, discrimination, n_attempts } produced by the
 * item-analysis recalc job. Colour-coded heuristic for trainers:
 *   p_value (difficulty): 0.2–0.8 is healthy; outside = too easy/hard
 *   discrimination: > 0.2 good, 0.1–0.2 ok, < 0.1 poor
 *
 * Extracted verbatim from QuestionBanksPage.jsx during the Phase 5 refactor
 * (no behaviour change).
 */
import { Activity } from 'lucide-react';

export function CalibrationPip({ calibration }) {
  if (!calibration || typeof calibration !== 'object') return null;
  const { p_value, discrimination, n_attempts } = calibration;
  if (n_attempts == null || n_attempts < 5) {
    return (
      <span
        className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-muted/50 text-[10px]"
        title={`Only ${n_attempts || 0} attempts — need ≥5 for reliable calibration`}
        data-testid="calibration-pip-uncalibrated"
      >
        <Activity className="w-3 h-3" />n={n_attempts || 0}
      </span>
    );
  }
  const pct = Math.round((p_value ?? 0) * 100);
  const healthy = p_value >= 0.2 && p_value <= 0.8;
  const discGood = discrimination >= 0.2;
  const discOk = discrimination >= 0.1;
  const cls = healthy && discGood
    ? 'bg-green-500/15 text-green-700 dark:text-green-400'
    : healthy && discOk
      ? 'bg-amber-500/15 text-amber-700 dark:text-amber-400'
      : 'bg-red-500/15 text-red-700 dark:text-red-400';
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] ${cls}`}
      title={`n=${n_attempts} · difficulty ${pct}% correct · discrimination ${(discrimination ?? 0).toFixed(2)}`}
      data-testid="calibration-pip"
    >
      <Activity className="w-3 h-3" />
      {pct}% · D {(discrimination ?? 0).toFixed(2)}
    </span>
  );
}
